"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContextProvider = exports.FormContext = exports.initialFormContextState = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var Types_1 = require("../Types");
var ValuationWidgetContext_1 = require("./ValuationWidgetContext");
var valuationWidgetResources = window.Resources.ValuationWidgetResources;
var defaultValuationMethod = Types_1.PublicValuationMethod.YearMakeModelDropdowns;
exports.initialFormContextState = {
    valuationMethod: defaultValuationMethod,
    plate: {
        plateNumber: "",
        state: ""
    },
    vin: {
        enteredVin: "",
        vinWasCorrected: false,
        attemptedVins: []
    },
    yearMakeModel: {
        year: "",
        make: "",
        model: ""
    },
    customerJourneyId: null,
    isReturningCustomer: false
};
exports.FormContext = (0, preact_1.createContext)(null);
var FormContextProvider = function (_a) {
    var children = _a.children, defaultState = _a.defaultState;
    var widgetContext = (0, hooks_1.useContext)(ValuationWidgetContext_1.ValuationWidgetContext);
    var _b = (0, hooks_1.useState)(__assign(__assign({}, defaultState), { customerJourneyId: widgetContext.configuration.customerJourneyId, isReturningCustomer: widgetContext.configuration.isReturningCustomer })), state = _b[0], setState = _b[1];
    var _c = (0, hooks_1.useState)(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var resetFormWithNewValue = function (cb) {
        setState(function (x) {
            var resetForm = __assign(__assign({}, x), { yearMakeModel: {
                    year: "",
                    make: "",
                    model: ""
                }, vin: {
                    enteredVin: null,
                    attemptedVins: [],
                    vinWasCorrected: false
                }, plate: {
                    plateNumber: null,
                    state: null
                } });
            if (cb) {
                cb(resetForm);
            }
            return resetForm;
        });
    };
    var handleDescribeVehicleNavigation = function () {
        resetFormWithNewValue();
        widgetContext.updateValuationMethod(widgetContext.configuration.showDropdowns ? Types_1.PublicValuationMethod.YearMakeModelDropdowns : Types_1.PublicValuationMethod.Vin);
    };
    var submitForm = function (onSubmitError) { return __awaiter(void 0, void 0, void 0, function () {
        var submitResponse, err_1, baseAlertOptions, requestTimedOut, valuationResponse, isOfferUpgradeError, showPlateNotFoundWarning, plateNotFoundMessage, showVinNotFoundWarning;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, new Promise(function (res, rej) {
                            setIsSubmitting(true);
                            $.ajax({
                                type: 'POST',
                                url: widgetContext.configuration.submitEndpoint,
                                cache: false,
                                contentType: 'application/json; charset=utf-8',
                                data: JSON.stringify(state),
                                timeout: 15000,
                                success: function (x) {
                                    if (x.status === WBAC.Models.ValuationResultStatus.Success) {
                                        res(x);
                                    }
                                    rej(x);
                                },
                                error: function (xhr, textstatus, msg) {
                                    if (textstatus === "timeout") {
                                        rej({ requestTimedOut: true, valuationMethod: state.valuationMethod });
                                    }
                                    else {
                                        rej();
                                    }
                                },
                                complete: function () { return setIsSubmitting(false); }
                            });
                        })];
                case 1:
                    submitResponse = _a.sent();
                    if (submitResponse.nextStep) {
                        window.location.href = submitResponse.nextStep;
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    onSubmitError();
                    baseAlertOptions = {
                        containerName: 'vin-plate-warning-dialog',
                    };
                    requestTimedOut = (err_1 === null || err_1 === void 0 ? void 0 : err_1.requestTimedOut) === true;
                    valuationResponse = err_1 === null || err_1 === void 0 ? void 0 : err_1.status;
                    isOfferUpgradeError = state.customerJourneyId !== undefined;
                    //If the VIN/LP Decode fails for any reason and it is on the Upgrade Offer dialog, we don't want to show any error message but the specific upgrade offer error messages
                    if (isOfferUpgradeError) {
                        WBAC.BookAppointment.disableUpgradeOffer(err_1 === null || err_1 === void 0 ? void 0 : err_1.upgradeOfferOldVehicleTitle, err_1 === null || err_1 === void 0 ? void 0 : err_1.upgradeOfferOldVehicleDescription, err_1 === null || err_1 === void 0 ? void 0 : err_1.upgradeOfferNewVehicleTitle, err_1 === null || err_1 === void 0 ? void 0 : err_1.upgradeOfferNewVehicleDescription, err_1 === null || err_1 === void 0 ? void 0 : err_1.upgradeOfferNewAmount);
                        return [2 /*return*/];
                    }
                    showPlateNotFoundWarning = state.valuationMethod === WBAC.Models.PublicValuationMethod.LicensePlate
                        && (valuationResponse === WBAC.Models.ValuationResultStatus.PlateNotFound || requestTimedOut);
                    if (showPlateNotFoundWarning) {
                        plateNotFoundMessage = valuationWidgetResources.Alert_CouldNotLocatePlateNumber.replace('{0}', state.plate.plateNumber);
                        WBAC.Dialog.alert(__assign(__assign({}, baseAlertOptions), { message: plateNotFoundMessage, buttons: [
                                { text: valuationWidgetResources.Alert_CouldNotLocatePlateNumber_EditPlate, closesDialog: true },
                                { text: valuationWidgetResources.Alert_CouldNotLocatePlateNumber_DescribeVehicle, closesDialog: true, callback: function () { return handleDescribeVehicleNavigation(); } }
                            ] }));
                        return [2 /*return*/];
                    }
                    showVinNotFoundWarning = state.valuationMethod === WBAC.Models.PublicValuationMethod.Vin
                        && (valuationResponse === WBAC.Models.ValuationResultStatus.VinNotFound || requestTimedOut);
                    if (showVinNotFoundWarning) {
                        WBAC.Dialog.alert(__assign(__assign({}, baseAlertOptions), { message: valuationWidgetResources.Alert_CouldNotDecodeVin, buttons: [
                                { text: valuationWidgetResources.Alert_CouldNotDecodeVin_EditVin, closesDialog: true },
                                { text: valuationWidgetResources.Alert_CouldNotDecodeVin_DescribeVehcile, closesDialog: true, callback: function () { return handleDescribeVehicleNavigation(); } }
                            ] }));
                        return [2 /*return*/];
                    }
                    WBAC.Dialog.alert(__assign(__assign({}, baseAlertOptions), { message: valuationWidgetResources.Alert_GenericDecodeAlert, buttons: [
                            { text: valuationWidgetResources.Alert_GenericDecodeAlert_Close, closesDialog: true, callback: function () { return handleDescribeVehicleNavigation(); } }
                        ] }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (0, preact_1.h)(exports.FormContext.Provider, { value: { formValue: state, resetFormWithNewValue: resetFormWithNewValue, submitForm: submitForm, isSubmitting: isSubmitting } }, children);
};
exports.FormContextProvider = FormContextProvider;
